


















import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import TextMonthChangePicker from "../components/common/TextMonthChangePicker.vue";
import BaseTable from "../components/common/BaseTable.vue";
import AxiosMixin from "../mixins/axiosMixin";
import { HeaderWidthItem, SearchCondition, ObjectId } from "@/types";
import { Ref } from "vue-property-decorator";
import LoadingDialog from "../components/common/LoadingDialog.vue";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";

const StoreYearmonth = namespace("yearmonth");

@Component({
  components: {
    TextMonthChangePicker,
    BaseTable,
    LoadingDialog
  }
})
export default class MedicalInsInvoice extends mixins(AxiosMixin) {
  @Ref("baseTable") private readonly baseTable!: BaseTable;

  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    this.setYearmonth(yearmonth);
  }

  private headerItems: HeaderWidthItem[] = [
    {
      value: "is_printed",
      text: "請求データ確定済",
      width: "86px"
    },
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px"
    },
    {
      value: "insured_no",
      text: "被保険者番号",
      width: "122px"
    },
    {
      value: "name",
      text: "氏名",
      width: "140px"
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "140px"
    },
    {
      value: "insurance_no",
      text: "保険者番号",
      width: "110px"
    },
    {
      value: "insurance_name",
      text: "保険者名",
      width: "160px"
    },
    {
      value: "yearmonth",
      text: "サービス提供年月",
      width: "148px"
    }
  ];

  private tableItems: object[] = [];

  mounted() {
    this.updateData(this.baseTable.getSearchCondition());
  }

  private updateData(searchCondition: SearchCondition) {
    this.postJsonCheck(
      window.base_url + "/api/office/medical/insinvoice/get",
      {
        yearmonth: this.yearmonth.replace("-", ""),
        only_not_printed: searchCondition.isDone,
        insurance_no: searchCondition.insuranceNo,
        insurance_name: searchCondition.insuranceName,
        ibow_id: searchCondition.userCode,
        furigana: searchCondition.userKana,
        insured_no: searchCondition.userInsNo
      },
      res => {
        this.tableItems = res.data.invoices;
        this.baseTable.refreshSelectItem();
        this.$nextTick(() => {
          this.baseTable.updateBaseTable();
        });
      }
    );
  }

  private search(searchCondition: SearchCondition) {
    this.updateData(searchCondition);
  }

  private done(objectIds: ObjectId[]) {
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/medical/insinvoice",
      {
        ids: objectIds.map(objectId => objectId.id)
      },
      res => {
        window.open(res.data.pdf_path);
      }
    );
  }

  private checked(objectIds: ObjectId[]) {
    const ids = [0];
    objectIds.forEach(objectId => {
      ids.push(objectId.id);
    });
    this.postJsonCheck(
      window.base_url + "/api/office/medical/insinvoice/checked",
      {
        ids: ids
      },
      () => {
        objectIds.forEach(item => {
          item.is_printed = "◯";
        });
      }
    );
  }

  private cancel(objectIds: ObjectId[]) {
    const ids = [0];
    objectIds.forEach(objectId => {
      ids.push(objectId.id);
    });
    this.postJsonCheck(
      window.base_url + "/api/office/medical/insinvoice/cancel",
      {
        ids: ids
      },
      () => {
        objectIds.forEach(item => {
          item.is_printed = "";
        });
      }
    );
  }
}
